import React from 'react'
import { Filter } from '@scentregroup/ui'
import trackMkpEvents, { labels } from '../../lib/market-place-track-event'

interface IProductTypeFilter {
  productTypes: string[]
  productTypeSelections: string[]
  onChangeProductTypeSelections(productTypeSelections: string[]): void
}

export const ProductTypeFilter: React.FunctionComponent<
  React.PropsWithChildren<IProductTypeFilter>
> = ({
  productTypes,
  productTypeSelections,
  onChangeProductTypeSelections,
}) => {
  return (
    <Filter
      name={'Type'}
      id={'type'}
      size={'SMALL'}
      filterOptions={productTypes?.map((option: string) => option)}
      selectedOptions={productTypes.filter(
        productType =>
          productTypeSelections.find(o => o === productType) !== undefined
      )}
      onSelectionChange={(
        selection: string[],
        { option, isChecked }: { isChecked: boolean; option: string }
      ) => {
        onChangeProductTypeSelections(
          productTypes.filter(option => selection.includes(option))
        )
        if (isChecked) {
          trackMkpEvents.selected(
            labels.createSelectedFilterFacet('Type', option)
          )
        } else {
          trackMkpEvents.unselected(
            labels.createSelectedFilterFacet('Type', option)
          )
        }
      }}
    />
  )
}

export default ProductTypeFilter
